import React, { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import Head from 'next/head';

import _isEmpty from 'lodash/isEmpty';

import { pageNames } from '@atc/bonnet-paths';
import { useBrand } from '@atc/brand';
import { useFeatures } from '@atc/features';

import {
    currentPageNameDuck,
    queryDuck,
} from '@/ducks';

import {
    srpContentDuck,
    srpLocationTypeDuck,
} from '@/ducks/srp';

// component
import CrawlPathLinks from '@/containers/CrawlPathLinks';

const { SEARCH_RESULTS } = pageNames;

const renderAltezzaMetaTags = ({
    queryId,
    editorialContent,
    selfServiceWindowTitle,
    selfServiceMetaDescription,
    selfServiceLocationHeading,
}) => {
    if (!queryId) {
        return null;
    }

    return (
        <Head>
            <meta
                name="selfServiceSeoQueryId"
                data-cmp="selfServiceSeoQueryId"
                content={queryId}
            />
            <meta
                data-cmp="SelfServiceEditorialContent"
                name="SelfServiceEditorialContent"
                content={!_isEmpty(editorialContent)}
            />
            <meta
                name="selfServiceWindowTitle"
                data-cmp="selfServiceWindowTitle"
                content={!!selfServiceWindowTitle}
            />
            <meta
                name="selfServiceMetaDescription"
                data-cmp="selfServiceMetaDescription"
                content={!!selfServiceMetaDescription}
            />
            <meta
                name="selfServiceLocationHeading"
                data-cmp="selfServiceLocationHeading"
                content={!!selfServiceLocationHeading}
            />
        </Head>
    );
};

function CrawlPathFooterContainer() {

    const {
        editorials,
        selfServiceWindowTitle,
        selfServiceMetaDescription,
        selfServiceLocationHeading,
    } = useSelector(srpContentDuck.selectors.getDuckState);

    const dispatch = useDispatch();

    const currentPageName = useSelector(currentPageNameDuck.selectors.getDuckState);
    const queryIdData = useSelector(srpContentDuck.selectors.getQueryId);
    const queryId = currentPageName === SEARCH_RESULTS ? queryIdData : {};
    const queryData = useSelector(queryDuck.selectors.getDuckState);
    const isNational = useSelector(srpLocationTypeDuck.selectors.getDuckState);

    const {
        // brand configs
        brand: [, { channel }],
        crawlPath: [enableCrawlPath, {
            trimData: enableTrimData,
            cityDataWithZip: enabledCityDataWithZip,
            topDealers: enableTopDealersData,
        }],
        seo_links: [isSeoLinksEnabled] = [],
        // optimizely
        enable_indexed_locations: [enableIndexedLocations],
        ddp_link: [, { ddp_base_path: ddpBasePath }],
        default_query_params: [enableDefaultQueryParams, { queryParams }],
    } = useFeatures([
        'brand',
        'crawlPath',
        'enable_indexed_locations',
        'ddp_link',
        'default_query_params',
        'seo_links',
    ]);

    const { brand } = useBrand();

    const [hasFetchedCrawlPath, setHasFetchedCrawlPath] = useState(false);
    // altezza tags are only needed for bots, not users, only include for debugging
    const includeSeoMetaTags = queryData.debugSeoMetaTags === 'true';

    useEffect(() => {
        if (!hasFetchedCrawlPath) {
            dispatch(srpContentDuck.creators.fetchCrawlPaths({
                brand,
                channel,
                query: {
                    ...queryData,
                },
                enableCrawlPath,
                enableDefaultQueryParams,
                enableIndexedLocations,
                enableTrimData,
                enabledCityDataWithZip,
                enableTopDealersData,
                isNational,
                ddpBasePath,
                queryParams,
            }));
            setHasFetchedCrawlPath(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hasFetchedCrawlPath]);

    return (
        <>
            {includeSeoMetaTags && (
                renderAltezzaMetaTags({
                    queryId,
                    editorialContent: editorials,
                    selfServiceWindowTitle,
                    selfServiceMetaDescription,
                    selfServiceLocationHeading,
                }))}
            {
                isSeoLinksEnabled && (
                    <CrawlPathLinks />
                )
            }
        </>
    );
}

export default CrawlPathFooterContainer;
